<template>
  <div>
    <!-- Encabezado -->
    <v-row>
      <v-col cols="12">
        <v-toolbar flat color="transparent">
          <v-toolbar-title>
            <h2>Reporte Comparativo de Ventas</h2>
          </v-toolbar-title>
        </v-toolbar>
      </v-col>
    </v-row>

    <!-- Filtro de Sucursales -->
    <v-row>
      <v-col cols="12" md="6">
        <v-select
          v-model="sucursalesSeleccionadas"
          :items="sucursales"
          item-text="nombre"
          item-value="id"
          label="Seleccionar sucursales"
          multiple
          chips
          clearable
        ></v-select>
      </v-col>
    </v-row>

    <!-- Tabla comparativa -->
    <v-card outlined>
      <v-card-title>
        Comparativa por Categoría y Sucursal
      </v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <thead>
            <tr>
              <th class="text-left">Categoría</th>
              <th
                class="text-center"
                v-for="sucursal in sucursalesFiltradas"
                :key="'th-' + sucursal.id"
              >
                {{ sucursal.nombre }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="categoria in categorias"
              :key="'cat-' + categoria"
            >
              <td>{{ categoria }}</td>
              <td
                v-for="sucursal in sucursalesFiltradas"
                :key="'cell-' + categoria + '-' + sucursal.id"
                class="text-center"
              >
                {{
                  obtenerTotalPorCategoriaYSucursal(
                    categoria,
                    sucursal.id
                  ) | currencyAR
                }}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td class="font-weight-bold">Total Sucursal</td>
              <td
                v-for="sucursal in sucursalesFiltradas"
                :key="'total-' + sucursal.id"
                class="text-center font-weight-bold"
              >
                {{ totalPorSucursal(sucursal.id) | currencyAR }}
              </td>
            </tr>
          </tfoot>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <!-- Tabla resumen -->
    <v-card outlined class="mt-4">
      <v-card-title>
        Total de Ventas por Sucursal
      </v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <thead>
            <tr>
              <th class="text-left">Sucursal</th>
              <th class="text-center">Total de Ventas</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="sucursal in sucursalesFiltradas"
              :key="'sum-' + sucursal.id"
            >
              <td>{{ sucursal.nombre }}</td>
              <td class="text-center">
                {{ totalPorSucursal(sucursal.id) | currencyAR }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "ReporteVentasComparativo",
  data() {
    return {
      sucursales: [
        { id: 1, nombre: "Sucursal Centro" },
        { id: 2, nombre: "Sucursal Norte" },
        { id: 3, nombre: "Sucursal Sur" },
      ],
      sucursalesSeleccionadas: [1, 2, 3], // Por defecto todas visibles
      ventas: [
        { categoria: "Electrónica", sucursalId: 1, monto: 120000 },
        { categoria: "Electrónica", sucursalId: 2, monto: 80000 },
        { categoria: "Hogar", sucursalId: 1, monto: 40000 },
        { categoria: "Hogar", sucursalId: 3, monto: 25000 },
        { categoria: "Muebles", sucursalId: 2, monto: 60000 },
        { categoria: "Muebles", sucursalId: 3, monto: 15000 },
      ],
    };
  },
  computed: {
    categorias() {
      return [...new Set(this.ventas.map((v) => v.categoria))];
    },
    sucursalesFiltradas() {
      return this.sucursales.filter((s) =>
        this.sucursalesSeleccionadas.includes(s.id)
      );
    },
  },
  methods: {
    obtenerTotalPorCategoriaYSucursal(categoria, sucursalId) {
      const total = this.ventas
        .filter(
          (v) =>
            v.categoria === categoria && v.sucursalId === sucursalId
        )
        .reduce((sum, v) => sum + v.monto, 0);
      return total;
    },
    totalPorSucursal(sucursalId) {
      return this.ventas
        .filter((v) => v.sucursalId === sucursalId)
        .reduce((sum, v) => sum + v.monto, 0);
    },
  },
  filters: {
    currencyAR(value) {
      if (value == null) return "$ 0";
      return `$ ${new Intl.NumberFormat("de-DE").format(value)}`;
    },
  },
};
</script>

<style scoped>
</style>
